export default {
    supportEmail: 'support@yoga-go.io',
};
